// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const noivern: PokeData = {
  "id": 715,
  "name": "noivern",
  "height": 15,
  "weight": 850,
  "base_experience": 187,
  "types": [
    PokeType.FLYING,
    PokeType.DRAGON
  ],
  "api_moves": [
    "razor-wind",
    "gust",
    "wing-attack",
    "whirlwind",
    "tackle",
    "bite",
    "supersonic",
    "absorb",
    "agility",
    "screech",
    "double-team",
    "leech-life",
    "super-fang",
    "moonlight",
    "air-cutter",
    "roost",
    "tailwind",
    "air-slash",
    "dragon-pulse",
    "hurricane",
    "boomburst"
  ],
  "moves": [
    "gust",
    "tackle",
    "bite",
    "supersonic",
    "moonlight",
    "roost",
    "tailwind",
    "air-slash",
    "dragon-pulse",
    "hurricane",
    "dragon-rush",
    "draco-meteor",
    "dragon-vortex"
  ],
  "evolution_chain": {
    "id": 367,
    "item": null,
    "species": [
      {
        "name": "noibat",
        "order": 714,
        "types": [
          PokeType.FLYING,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "noivern",
        "order": 715,
        "types": [
          PokeType.FLYING,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 714,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 48,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 109,
    "speed": 163,
    "ability_power": 128
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
